module.exports = __webpack_public_path__ + "img/manage01.54af8baf.png";